import React, { useEffect, useMemo, useState } from "react";
import { fetchSitePlaces, createSitePlace, deleteSitePlace, fetchSites } from "./services/api";
import { PMSitePlace, PMSite } from "./types";
import { Button, Col, Form, Row } from "react-bootstrap";

const PMSitePlacePage: React.FC = () => {
    const [sitePlaces, setSitePlaces] = useState<PMSitePlace[]>([]);
    const [sites, setSites] = useState<PMSite[]>([]);
    const [newSitePlace, setNewSitePlace] = useState<{
        site: number;
        place_name: string;
        reader_macid: string;
        rfid_antena: string;
    }>({
        site: 0,
        place_name: "",
        reader_macid: "",
        rfid_antena: ""
    });

    useEffect(() => {
        getSitePlaces();
        getSites();
    }, []);

    const getSitePlaces = async () => {
        const res = await fetchSitePlaces();
        setSitePlaces(res);
    };

    const getSites = async () => {
        const res = await fetchSites();
        setSites(res);
    };

    const addSitePlace = async () => {
        if (!newSitePlace.site || !newSitePlace.place_name || !newSitePlace.reader_macid || !newSitePlace.rfid_antena) return;
        await createSitePlace(newSitePlace);
        setNewSitePlace({
            site: 0,
            place_name: "",
            reader_macid: "",
            rfid_antena: ""
        });
        getSitePlaces();
    };

    const handleDeleteSitePlace = async (id?: number) => {
        if (!id) return;
        await deleteSitePlace(id);
        getSitePlaces();
    };

    const sortedSitePlaces = useMemo(() => {
        return [...sitePlaces].sort((a, b) => {
            const aName = sites.find(site => site.id === a.site)?.site_name || '';
            const bName = sites.find(site => site.id === b.site)?.site_name || '';
            return aName.localeCompare(bName);
        });
    }, [sitePlaces, sites]);

    return (
        <div className="p-4 p-md-5">
            <h2 className="mb-4">Mac ID Against Reader Details</h2>
            <Form className="mb-3">
                <Row className="g-2 align-items-center">
                    <Col md={3}>
                        <Form.Group className="mb-4">
                            <Form.Label>Site</Form.Label>
                            <Form.Select
                                value={newSitePlace.site}
                                onChange={e => setNewSitePlace({ ...newSitePlace, site: parseInt(e.target.value) })}
                            >
                                <option value={0}>Select Site</option>
                                {sites.map((site) => (
                                    <option key={site.id} value={site.id}>
                                        {site.site_name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group className="mb-4">
                            <Form.Label>Lane Position</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter place name"
                                value={newSitePlace.place_name}
                                onChange={e => setNewSitePlace({ ...newSitePlace, place_name: e.target.value })}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group className="mb-4">
                            <Form.Label>Reader MAC ID</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter MAC ID"
                                value={newSitePlace.reader_macid}
                                onChange={e => setNewSitePlace({ ...newSitePlace, reader_macid: e.target.value })}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group className="mb-4">
                            <Form.Label>RFID Antenna</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter antenna"
                                value={newSitePlace.rfid_antena}
                                onChange={e => setNewSitePlace({ ...newSitePlace, rfid_antena: e.target.value })}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Button className="btn btn-primary" onClick={addSitePlace}>
                            Add Place
                        </Button>
                    </Col>
                </Row>
            </Form>

            {/* Site Places Table */}
            <div className="row">
                <div className="col-md-12">
                    <table className="table table-bordered align-middle">
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: "8%" }}>ID</th>
                                <th style={{ width: "20%" }}>Site</th>
                                <th style={{ width: "20%" }}>Lane Position</th>
                                <th style={{ width: "20%" }}>Reader MAC ID</th>
                                <th style={{ width: "20%" }}>RFID Antenna</th>
                                <th style={{ width: "12%" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sitePlaces.length > 0 ? (
                                sortedSitePlaces.map((place) => (
                                    <tr key={place.id}>
                                        <td>{place.id}</td>
                                        <td>
                                            {sites.find(site => site.id === place.site)?.site_name || 'Unknown'}
                                        </td>
                                        <td>{place.place_name}</td>
                                        <td>{place.reader_macid}</td>
                                        <td>{place.rfid_antena}</td>
                                        <td>
                                            <button
                                                className="btn btn-sm btn-danger"
                                                onClick={() => handleDeleteSitePlace(place.id)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6} className="text-center">
                                        No site places found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PMSitePlacePage;
